import { apiGet, apiPost } from './client';
import type {
  QueueJob,
  QueueStatsResponse,
  ProcessQueueResponse,
} from '../types/api';

// Re-export types for consumers
export type { QueueJob, QueueStatsResponse, ProcessQueueResponse };

export type QueueStatusResponse = QueueJob[];

export async function getQueueStatus(): Promise<QueueStatusResponse> {
  return apiGet<QueueStatusResponse>('/api/queue/status');
}

export async function getQueueStats(): Promise<QueueStatsResponse> {
  return apiGet<QueueStatsResponse>('/api/queue/stats');
}

export async function triggerProcessing(): Promise<ProcessQueueResponse> {
  return apiPost<ProcessQueueResponse>('/api/queue/process');
}

/** A build that exhausted its retries and stopped. */
export interface FailedQueueJob {
  id: string;
  website_id: string;
  business_name: string | null;
  email: string | null;
  website_status: string | null;
  retry_count: number | null;
  queued_at: string | null;
  completed_at: string | null;
  error_message: string | null;
}

export async function getFailedJobs(): Promise<FailedQueueJob[]> {
  return apiGet<FailedQueueJob[]>('/api/queue/failed');
}

export interface RetryBuildResponse {
  success: boolean;
  jobId: string;
  websiteId: string;
  message: string;
}

export async function retryBuild(websiteId: string): Promise<RetryBuildResponse> {
  return apiPost<RetryBuildResponse>('/api/queue/retry', { websiteId });
}
